// extracted by mini-css-extract-plugin
export default {"container":"topArea_container__avY+Z","buttonGroup":"topArea_buttonGroup__h7td5"};